import brand from '@helpers/brand';
import styled from 'styled-components';
const ErrorArea = styled.div `
  padding-top: 20px;
  color: ${brand.validation.invalid};
`;
const ErrorTitle = styled.h5 `
  margin-bottom: 5px;
`;
const ErrorSummary = styled.p `
  margin-bottom: 10px;
`;
const ErrorList = styled.ul `
  list-style: disc;
  padding-left: 20px;
`;
const ErrorListItem = styled.li `
  margin-bottom: 5px;
`;
export default {
    ErrorArea,
    ErrorList,
    ErrorListItem,
    ErrorSummary,
    ErrorTitle,
};
